<rid-assignment-background />

<rid-algorithm class="h-full" (finished)="finish()" />
